import * as React from "react";
import {withRouter} from "react-router-dom";
import * as routes from "../../constants/routes";
import {firebase} from "../../firebase";
import {FirebaseAuth} from "react-firebaseui";



const SignInComponent = ({history}: { [key: string]: any }) => {

    const uiConfig = {
        // Popup signin flow rather than redirect flow.
        signInFlow: 'popup',
        // We will display Google and Facebook as auth providers.
        signInOptions: [
            {
                provider: firebase.googleAuthProviderID,
                scopes: [
                    // Your requested scopes.
                    'https://www.googleapis.com/auth/plus.login'
                ],
                customParameters: {
                    // Forces account selection even when one account
                    // is available.
                    hd: 'remerge.io'
                }
            }

        ],
        callbacks: {
            signInSuccessWithAuthResult: (result: any, redirectUrl: string) => {
                history.push(routes.ADS);
                return true
            }
        }
    };

    return (
        <FirebaseAuth
            uiConfig={uiConfig}
            firebaseAuth={firebase.auth}
        />

    )
};

export const SignIn = withRouter(SignInComponent);